/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getSuggestedReorders} from '../api'

 export const useQueryGetSuggestedReorders = createReactQueryHook('getSuggestedReorders', getSuggestedReorders)
